"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyUUID = exports.UUID = void 0;
/** UUID is a support class for Universally Unique ID. These mainly support validation and checking */

var UUID =
/** @class */
function () {
  function UUID(uuid) {
    if (this.validate(uuid)) {
      this._uuid = uuid;
    } else {
      throw RangeError("Invalid UUID given");
    }
  }
  /** string is the accessor to the string version of the UUID */


  UUID.prototype.string = function () {
    return this._uuid.toLowerCase();
  };
  /** toJSON serializes this to json */


  UUID.prototype.toJSON = function () {
    return this.string();
  };
  /** contains searches for a partial or total match of an uuid and returns true of this uuid contains the search term */


  UUID.prototype.contains = function (term) {
    return this.string().indexOf(term) > -1;
  };
  /** equals is the comparison operator for UUID */


  UUID.prototype.equals = function (u) {
    if (typeof u === 'string') {
      return this.string() === u;
    }

    return this.string() === u.string();
  };
  /** Validates the validity of a candidate UUID.
   *  Please note: This is not a complete validator and only allows canonical formatted UUIDs (with dashes) */


  UUID.prototype.validate = function (rawUUID) {
    if (rawUUID.length < 35) {
      return false;
    }

    var re = RegExp(/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/);
    return re.test(rawUUID);
  };
  /** Checks if this UUID is valid. There should not really be any way of constructing invalid UUIDs but you never know with JS.
   * This function just calls validate with the internal UUID representation */


  UUID.prototype.valid = function () {
    return this.validate(this._uuid);
  };
  /** Checks if this UUID is all zeroes.  */


  UUID.prototype.isZero = function () {
    return this._uuid === "00000000-0000-0000-0000-000000000000";
  };

  return UUID;
}();

exports.UUID = UUID;

function EmptyUUID() {
  return new UUID("00000000-0000-0000-0000-000000000000");
}

exports.EmptyUUID = EmptyUUID;